module.exports = __webpack_public_path__ + "static/media/TipsTiangle.75b27690.png";